function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.23 22.6289C20.2733 22.6289 19.3478 22.4733 18.4844 22.1933C18.2122 22.1 17.9089 22.17 17.6989 22.38L16.4778 23.9122C14.2767 22.8622 12.2156 20.8789 11.1189 18.6L12.6356 17.3089C12.8456 17.0911 12.9078 16.7878 12.8222 16.5156C12.5344 15.6522 12.3867 14.7267 12.3867 13.77C12.3867 13.35 12.0367 13 11.6167 13H8.92556C8.50556 13 8 13.1867 8 13.77C8 20.9956 14.0122 27 21.23 27C21.7822 27 22 26.51 22 26.0822V23.3989C22 22.9789 21.65 22.6289 21.23 22.6289Z",
  fill: "#217BC7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 9.75C18 9.33579 18.3358 9 18.75 9H25.25C25.6642 9 26 9.33579 26 9.75V16.25C26 16.6642 25.6642 17 25.25 17C24.8358 17 24.5 16.6642 24.5 16.25V11.5607L20.5303 15.5303C20.2374 15.8232 19.7626 15.8232 19.4697 15.5303C19.1768 15.2374 19.1768 14.7626 19.4697 14.4697L23.4393 10.5H18.75C18.3358 10.5 18 10.1642 18 9.75ZM18 17.75C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25C17.5858 16.25 17.25 16.5858 17.25 17C17.25 17.4142 17.5858 17.75 18 17.75ZM16.75 19C16.75 19.4142 16.4142 19.75 16 19.75C15.5858 19.75 15.25 19.4142 15.25 19C15.25 18.5858 15.5858 18.25 16 18.25C16.4142 18.25 16.75 18.5858 16.75 19Z",
  fill: "#217BC7"
});

function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.8b3c24a5.svg";
export { ForwardRef as ReactComponent };